export const ordersStrings = {
  english: {
    order: 'Order',
    date: 'Date',
    status: 'Status',
    total: 'Total',
    actions: 'Actions',
    view: 'VIEW',
    manage: 'MANAGE',
  },

  japan: {
    order: '注文内容',
    date: '注文日',
    status: 'ステータス',
    total: '合計',
    actions: '操作',
    view: '表示',
    manage: 'MANAGE',
  },
};

export const orderDetailsStrings = {
  english: {
    title: 'ORDER DETAILS',
    order: 'Order # ',
    placed: 'was placed on',
    currency: 'and is currently',
    product: 'Product',
    total: 'total',
    manage: 'You can manage your keys from My Account',
    pay: 'PAYMENT METHOD:',
    TOTAL: 'TOTAL:',
    info: 'BILLING INFORMATION',
  },

  japan: {
    title: '注文内容',
    order: 'Order #',
    placed: 'was placed on',
    currency: 'and is currently',
    product: '注文商品',
    total: '合計',
    pay: '決済方法:',
    TOTAL: '小計:',
    info: '請求先住所',
  },
};

export const licensesStrings = {
  english: {
    title: 'MY ORDER LICENSE KEYS',
    key: 'License Key',
    status: 'Status',
    action: 'Action',
  },

  japan: {
    title: '購入したライセンスキー',
    key: 'ライセンスキー',
    status: 'ステータス',
    action: 'アクション',
  },
};
